export default class Product {
    constructor(productFormSelector = '[data-ui-el="order-add-form"]') {
        const form = document.querySelector(productFormSelector);

        if (!form) {
            return false;
        }

        this.form = form;
        this.prices = this.getProductPrice(form);
        this.sizes = this.getProductSizes(form);
        this.activeSize = this.getActiveSize();
        this.activePrice = this.getActivePrice(form);
        this.currentQuantity = form.querySelector('[data-id="quantity"]').value;
    }

    getProductPrice(form = this.form) {
        return {
            coin: form.querySelector('[data-element="price"]')?.textContent,
            coinSpecial: form.querySelector('[data-element="special_price"]')?.textContent,
            uah: form.querySelector('[data-element="price_uah"]')?.textContent,
            uahSpecial: form.querySelector('[data-element="special_price_uah"]')?.textContent,
        };
    }

    getProductSizes(form = this.form) {
        const sizeInputs = form.querySelectorAll('input[name="size_id"]');

        if (!sizeInputs.length) {
            return false;
        }

        return [...sizeInputs].map(input => {
            const prices = JSON.parse(input.dataset.prices);

            return {
                id: input.value,
                quantity: input.dataset.quantity,
                name: input.dataset.sizename,
                isActive: input.checked || input.dataset.size === 'one-size',
                prices,
            };
        });
    }

    getActiveSize() {
        return this.sizes.find(item => item.isActive);
    }

    getActivePrice(form = this.form) {
        const priceInputs = form.querySelectorAll('input[name="currency"]');

        return [...priceInputs].find(item => item.checked)?.value;
    }
}
